import { DefaultPlatformFormation, FormationConfig, FormationConfigMap } from '../../types/formation';


export const defaultFormationOptions: DefaultPlatformFormation[] = [
  '433',
  '442',
  '4312',
  '4231',
  '4141',
  '4411',
  '343',
  '3421',
  '3412',
  '352',
  '541',
  '523',
  '532',
];


export const maxFormationSortOrder = 15;

export const defaultFormationToSortOrder: Record<DefaultPlatformFormation, number> = {
  '433': maxFormationSortOrder,
  '442': maxFormationSortOrder - 1,
  '4312': maxFormationSortOrder - 2,
  '4231': maxFormationSortOrder - 3,
  '4141': maxFormationSortOrder - 4,
  '4411': maxFormationSortOrder - 5,
  '343': maxFormationSortOrder - 6,
  '3421': maxFormationSortOrder - 7,
  '3412': maxFormationSortOrder - 8,
  '352': maxFormationSortOrder - 9,
  '541': maxFormationSortOrder - 10,
  '523': maxFormationSortOrder - 11,
  '532': maxFormationSortOrder - 12,
};


export const defaultFormationConfig433: FormationConfig = {
  'S': { x: 7, y: 0 },
  'LW': { x: 2, y: 1 },
  'RW': { x: 12, y: 1 },
  'LCM': { x: 3, y: 6 },
  'RCM': { x: 11, y: 6 },
  'CDM': { x: 7, y: 7 },
  'LB': { x: 1, y: 11 },
  'LCB': { x: 5, y: 12 },
  'RCB': { x: 9, y: 12 },
  'RB': { x: 13, y: 11 },
  'GK': { x: 7, y: 16 }
};


export const defaultFormationConfig442: FormationConfig = {
  'LS': { x: 4, y: 0 },
  'RS': { x: 10, y: 0 },
  'LM': { x: 1, y: 5 },
  'LCM': { x: 5, y: 6 },
  'RCM': { x: 9, y: 6 },
  'RM': { x: 13, y: 5 },
  'LB': { x: 1, y: 11 },
  'LCB': { x: 5, y: 12 },
  'RCB': { x: 9, y: 12 },
  'RB': { x: 13, y: 11 },
  'GK': { x: 7, y: 16 }
};


export const defaultFormationConfig4312: FormationConfig = {
  'LS': { x: 4, y: 0 },
  'RS': { x: 10, y: 0 },
  'CAM': { x: 7, y: 3 },
  'LCM': { x: 3, y: 6 },
  'RCM': { x: 11, y: 6 },
  'CDM': { x: 7, y: 8 },
  'LB': { x: 1, y: 11 },
  'LCB': { x: 5, y: 12 },
  'RCB': { x: 9, y: 12 },
  'RB': { x: 13, y: 11 },
  'GK': { x: 7, y: 16 }
};


export const defaultFormationConfig4231: FormationConfig = {
  'S': { x: 7, y: 0 },
  'LW': { x: 1, y: 5 },
  'RW': { x: 13, y: 5 },
  'CAM': { x: 7, y: 4 },
  'LCM': { x: 4, y: 7 },
  'RCM': { x: 10, y: 7 },
  'LB': { x: 1, y: 11 },
  'LCB': { x: 5, y: 12 },
  'RCB': { x: 9, y: 12 },
  'RB': { x: 13, y: 11 },
  'GK': { x: 7, y: 16 }
};


export const defaultFormationConfig4141: FormationConfig = {
  'S': { x: 7, y: 0 },
  'LM': { x: 0, y: 5 },
  'LCM': { x: 4, y: 6 },
  'RCM': { x: 10, y: 6 },
  'RM': { x: 14, y: 5 },
  'CDM': { x: 7, y: 8 },
  'LB': { x: 1, y: 11 },
  'LCB': { x: 5, y: 12 },
  'RCB': { x: 9, y: 12 },
  'RB': { x: 13, y: 11 },
  'GK': { x: 7, y: 16 }
};


export const defaultFormationConfig4411: FormationConfig = {
  'S': { x: 7, y: 0 },
  'CAM': { x: 7, y: 4 },
  'LM': { x: 0, y: 6 },
  'LCM': { x: 4, y: 7 },
  'RCM': { x: 10, y: 7 },
  'RM': { x: 14, y: 6 },
  'LB': { x: 1, y: 11 },
  'LCB': { x: 5, y: 12 },
  'RCB': { x: 9, y: 12 },
  'RB': { x: 13, y: 11 },
  'GK': { x: 7, y: 16 }
};


export const defaultFormationConfig343: FormationConfig = {
  'S': { x: 7, y: 0 },
  'LW': { x: 2, y: 1 },
  'RW': { x: 12, y: 1 },
  'LM': { x: 0, y: 6 },
  'LCM': { x: 5, y: 6 },
  'RCM': { x: 9, y: 6 },
  'RM': { x: 14, y: 6 },
  'LCB': { x: 3, y: 11 },
  'CB': { x: 7, y: 12 },
  'RCB': { x: 11, y: 11 },
  'GK': { x: 7, y: 16 }
};


export const defaultFormationConfig3421: FormationConfig = {
  'S': { x: 7, y: 0 },
  'LCAM': { x: 3, y: 2 },
  'RCAM': { x: 11, y: 2 },
  'LM': { x: 0, y: 6 },
  'LCM': { x: 5, y: 7 },
  'RCM': { x: 9, y: 7 },
  'RM': { x: 14, y: 6 },
  'LCB': { x: 3, y: 11 },
  'CB': { x: 7, y: 12 },
  'RCB': { x: 11, y: 11 },
  'GK': { x: 7, y: 16 }
};


export const defaultFormationConfig3412: FormationConfig = {
  'LS': { x: 4, y: 0 },
  'RS': { x: 10, y: 0 },
  'CAM': { x: 7, y: 3 },
  'LM': { x: 0, y: 6 },
  'LCM': { x: 5, y: 7 },
  'RCM': { x: 9, y: 7 },
  'RM': { x: 14, y: 6 },
  'LCB': { x: 3, y: 11 },
  'CB': { x: 7, y: 12 },
  'RCB': { x: 11, y: 11 },
  'GK': { x: 7, y: 16 }
};


export const defaultFormationConfig352: FormationConfig = {
  'LS': { x: 4, y: 0 },
  'RS': { x: 10, y: 0 },
  'LM': { x: 0, y: 5 },
  'LCM': { x: 4, y: 6 },
  'RCM': { x: 10, y: 6 },
  'RM': { x: 14, y: 5 },
  'CDM': { x: 7, y: 8 },
  'LCB': { x: 3, y: 11 },
  'CB': { x: 7, y: 12 },
  'RCB': { x: 11, y: 11 },
  'GK': { x: 7, y: 16 }
};


export const defaultFormationConfig541: FormationConfig = {
  'S': { x: 7, y: 0 },
  'LM': { x: 0, y: 5 },
  'LCM': { x: 5, y: 6 },
  'RCM': { x: 9, y: 6 },
  'RM': { x: 14, y: 5 },
  'LWB': { x: 0, y: 10 },
  'LCB': { x: 4, y: 12 },
  'CB': { x: 7, y: 12 },
  'RCB': { x: 10, y: 12 },
  'RWB': { x: 14, y: 10 },
  'GK': { x: 7, y: 16 }
};


export const defaultFormationConfig523: FormationConfig = {
  'S': { x: 7, y: 0 },
  'LW': { x: 2, y: 1 },
  'RW': { x: 12, y: 1 },
  'LCM': { x: 5, y: 6 },
  'RCM': { x: 9, y: 6 },
  'LWB': { x: 0, y: 10 },
  'LCB': { x: 4, y: 12 },
  'CB': { x: 7, y: 12 },
  'RCB': { x: 10, y: 12 },
  'RWB': { x: 14, y: 10 },
  'GK': { x: 7, y: 16 }
};


export const defaultFormationConfig532: FormationConfig = {
  'LS': { x: 4, y: 0 },
  'RS': { x: 10, y: 0 },
  'LCM': { x: 3, y: 6 },
  'RCM': { x: 11, y: 6 },
  'CDM': { x: 7, y: 7 },
  'LWB': { x: 0, y: 10 },
  'LCB': { x: 4, y: 12 },
  'CB': { x: 7, y: 12 },
  'RCB': { x: 10, y: 12 },
  'RWB': { x: 14, y: 10 },
  'GK': { x: 7, y: 16 }
};


export const defaultFormationConfigMap: FormationConfigMap = {
  '433': defaultFormationConfig433,
  '442': defaultFormationConfig442,
  '4312': defaultFormationConfig4312,
  '4231': defaultFormationConfig4231,
  '4141': defaultFormationConfig4141,
  '4411': defaultFormationConfig4411,
  '343': defaultFormationConfig343,
  '3421': defaultFormationConfig3421,
  '3412': defaultFormationConfig3412,
  '352': defaultFormationConfig352,
  '541': defaultFormationConfig541,
  '523': defaultFormationConfig523,
  '532': defaultFormationConfig532
};
